import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import UserHeader from "../components/Dashboard/UserHeader";

import Footer from "../components/Dashboard/Footer";
import BottomNav from "../components/Dashboard/BottomNav";
import Dashboard from "../Layouts/User/dashboard/Dashboard";
import Profile from "../Layouts/User/Profile/Profile";
import Watchlist from "../Layouts/User/Watchlist/Watchlist";
import LedgerReport from "../Layouts/User/ledgerReport/LedgerReport";
import Order from "../Layouts/User/order/Order";
import BalanceStatement from "../Layouts/User/balanceStatement/BalanceStatement";
import PaymentHistory from "../Layouts/User/paymentHistory/PaymentHistory";
import News from "../Layouts/User/news/News";
import TradeStatement from "../Layouts/User/tradeStatement/TradeStatement";
import Portfolio from "../Layouts/User/portfolio/Portfolio";
import Fund from "../Layouts/User/Fund/Fund";
import Deposit from "../Layouts/User/Fund/Deposit";
import Withdraw from "../Layouts/User/Fund/Withdraw";
import PrivacyPolicy from "../Layouts/User/privacyPolicy/PrivacyPolicy"
import Registeredbank from "../Layouts/User/registeredbank/Registeredbank"
import TermCondition from "../Layouts/User/termcondition/TermCondition";
import ReferCode from "../Layouts/User/refercode/ReferCode";
import OptionChain from "../Layouts/User/optionchain/OptionChain";
import OptionChain1 from "../Layouts/User/optionchain/OptionChain1";
import KycDocument from "../Layouts/User/kycdocument/kycdocument";
import Favoriteslist from "../Layouts/User/Favrorites/Favoriteslist";
import Researchs from "../Layouts/User/research/Researchs";
const UserRoutes = () => {
  useEffect(() => {
    document.body.setAttribute("data-header-position", "fixed");
    return () => {
    };
  }, []);

  return (
    <div id="main-wrapper" className={`wallet-open show `}>
      <style>
        {`
          @media (max-width: 768px) {
            .content-body {
              padding-top: 50px !important;
              padding-left: 0 !important;
              padding-right: 0 !important;
              min-height: auto !important;
              // padding-bottom: 80px !important;
            }
            .main-content-area .container-fluid {
              padding-left: 0 !important;
              padding-right: 0 !important;
            }
            .nav-header {
              height: 70px !important;
            }
            // .card-body {
            //   padding: 10px !important;
            // }
            // .card-header {
            //   padding: 10px !important;
            // }
            .table > tbody > tr > td, .table > thead > tr > th {
              padding: 4px !important;
              font-size: 11px !important;
            }
            .btn {
              padding: 4px 8px !important;
              font-size: 11px !important;
            }
            .main-content-area {
              width: 100% !important;
            }
            .watchlist-global-sidebar {
              display: none !important;
            }
          }
          @media (min-width: 769px) {
            .header {
              z-index: 1050 !important;
            }
            .nav-header {
              z-index: 1060 !important;
            }
            .main-content-area .container-fluid {
              padding-left: 0 !important;
              padding-right: 0 !important;
            }
            [data-sidebar-style="mini"] .dlabnav {
              position: fixed !important;
              top: 80px !important;
              height: calc(100vh - 80px) !important;
              padding-bottom: 20px !important;
              z-index: 1040 !important;
              background-color: #fff !important;
              border-right: 1px solid #eee !important;
            }
            [data-sidebar-style="mini"] .dlabnav-scroll {
              height: calc(100vh - 80px) !important;
              overflow-y: auto !important;
              overflow-x: hidden !important;
            }
            [data-sidebar-style="mini"] .dlabnav-scroll::-webkit-scrollbar {
              width: 3px;
            }
            [data-sidebar-style="mini"] .dlabnav-scroll::-webkit-scrollbar-thumb {
              background-color: #ccc;
            }
            [data-sidebar-style="mini"] .nav-header .nav-control {
              display: flex !important;
              position: absolute;
              right: 0;
              z-index: 9999;
              justify-content: center;
              align-items: center;
            }
            [data-sidebar-style="mini"] .nav-header {
              width: 80px !important;
              overflow: hidden;
            }
            [data-sidebar-style="mini"] .nav-header .nav-control .hamburger {
              display: block !important;
            }
            [data-sidebar-style="mini"] .nav-header .hamburger .line {
              background: #fff !important;
            }
            .main-content-area {
              flex: 1 1 0%;
              min-width: 0;
            }
          }
        `}
      </style>
      <UserHeader />
      <div className="content-body px-2" style={{ minHeight: "calc(100vh - 150px)", paddingTop: "150px", marginLeft: "0" }}>
        <div className="d-flex flex-row w-100 ">

          {/* Watchlist Sidebar (Desktop only) */}
          <div className="watchlist-global-sidebar" style={{ width: "320px", minWidth: "320px", borderRight: "1px solid #ddd", background: "#fff", position: "sticky", top: "80px", height: "calc(100vh - 110px)", overflowY: "auto", borderRadius: "8px", zIndex: 2 }}>
            <Watchlist isSidebar={true} />
          </div>

          {/* Main Content */}
          <div className="main-content-area flex-grow-1" style={{ minHeight: "100%", padding: "0" }}>
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/watchlist" element={<Watchlist />} />
              <Route path="/orders" element={<Order />} />
              <Route path="/trade-statement" element={<TradeStatement />} />
              <Route path="/ledger-report" element={<LedgerReport />} />
              <Route path="/balance-statement" element={<BalanceStatement />} />
              <Route path="/bank-details" element={<Registeredbank />} />
              <Route path="/payment-history" element={<PaymentHistory />} />
              <Route path="/news" element={<News />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermCondition />} />
              <Route path="/refer" element={<ReferCode />} />
              <Route path="/option-chain" element={<OptionChain />} />
              <Route path="/option-chain1" element={<OptionChain1 />} />
              <Route path="/kyc" element={<KycDocument />} />
              <Route path="/favorites" element={<Favoriteslist />} />
              <Route path="/research" element={<Researchs />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/fund" element={<Fund />} />
              <Route path="/deposit" element={<Deposit />} />
              <Route path="/withdraw" element={<Withdraw />} />
            </Routes>
          </div>

          {/* Right Sidebar Container for Inline Widgets (Buy/Sell) */}
          <div id="right-sidebar-container" style={{ transition: "width 0.3s" }}></div>
        </div>
      </div>
      <Footer />
      <BottomNav />
    </div>
  );
};

export default UserRoutes;
